import { Select } from "antd";

import { AppStrings } from "../../../../utils/constants/AppStrings";
import type { AdminPage } from "../../../../queries/casino-configuration/views/useAdminViews";
import { useCurationDisplayName } from "../../../../hooks/useCurationDisplayName";

type ViewsPageSelectorProps = {
  pages: AdminPage[];
  value: string;
  onChange: (code: string) => void;
  ariaLabel: string;
};

/**
 * Storefront page selector for the Views configuration screen. Presentational
 * only — the parent owns the selected page code and decides when the selector
 * is shown (live_casino flag on and more than one page). Rendered as a dropdown
 * so the control scales as pages are added server-side without UI changes.
 */
function ViewsPageSelector({
  pages,
  value,
  onChange,
  ariaLabel,
}: ViewsPageSelectorProps) {
  const { getName } = useCurationDisplayName();
  return (
    <Select
      className="views-page-select"
      value={value || undefined}
      onChange={(code) => onChange(code)}
      aria-label={ariaLabel}
      options={pages.map((page) => {
        const displayName = getName(page);
        return {
          value: page.code,
          // Canonical name stays reachable via `title` because search on the
          // storefront pages is keyed by the canonical (English) name.
          title: displayName !== page.name ? page.name : undefined,
          label: page.is_default
            ? `${displayName} ${AppStrings.CASINO_CONFIG_VIEWS_PAGE_DEFAULT_SUFFIX}`
            : displayName,
        };
      })}
    />
  );
}

export default ViewsPageSelector;
